import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const DomainCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Text>{rowData.domain}</Text>
            </Stack>
        </Box>
    );
};

const DomainColumn = () => ({
    accessorKey: 'domain',
    header: 'Domain',
    size: 2,
    minSize: 160,
    Cell: ({ cell }) => <DomainCell cell={cell} />,
});
export default DomainColumn;
